import { typeInfo } from "../../../../constants/typeInfo";

const UserInputBar = ({
  handleChange,
  userInput,
  type,
  handleSetAnswer = null,
  hint = null,
  disabled = false,
  onlyUnderline = false,
  isSubmitted = false,
}) => {
  return (
    <>
      <input
        type="text"
        value={userInput}
        onChange={handleChange}
        disabled={isSubmitted || disabled}
        onKeyDown={(e) => {
          if (handleSetAnswer && e.key === "Enter") {
            handleSetAnswer(userInput);
          }
        }}
        style={{
          width: onlyUnderline ? "calc(100% - 60px)" : "100%",
          padding: "12px",
          paddingLeft: hint ? "42px" : "12px",
          fontSize: "18px",
          borderRadius: !onlyUnderline && "5px",
          backgroundColor: isSubmitted && typeInfo[type].backgroundColor,
          border: onlyUnderline
            ? "none"
            : disabled
            ? "1px solid #737373"
            : "1px solid " + typeInfo[type].color,
          borderBottom:
            (onlyUnderline && !isSubmitted) || disabled
              ? "1px solid #737373"
              : "1px solid " + typeInfo[type].color,
        }}
        placeholder={hint ? "" : "답을 입력해주세요."}
      />
      {handleSetAnswer && (
        <button
          onClick={() => handleSetAnswer(userInput)}
          style={{
            position: "absolute",
            top: "60%",
            right: hint ? "-40px" : "-10px",
            transform: "translateY(-50%)",
            background: "transparent", // 버튼 배경 투명
            border: "none", // 테두리 제거
            cursor: "pointer",
            fontSize: "30px",
            color: "#737373",
          }}
          disabled={disabled}
        >
          ↵
        </button>
      )}
      <span
        style={{
          position: "absolute",
          left: "25px",
          top: "40%",
          transform: "translateY(-50%)",
          fontSize: "24px",
          color: typeInfo[type].color,
          pointerEvents: "none",
        }}
      >
        {hint}
      </span>
    </>
  );
};

export default UserInputBar;
